<p-dialog
  header="Assign Device and/or Voice Profile"
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [style]="{ width: '50vw' }"
  (onHide)="onCloseDialog()">

  <p>
    Assign a Device/Voice Profile to one or more devices.
  </p>

  <p-table
    [value]="devices"
    responsiveLayout="scroll"
    styleClass="p-datatable-sm p-datatable-striped">
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Serial</th>
        <th>Org</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-device>
      <tr>
        <td>{{ device.name || 'No Name Assigned' }}</td>
        <td>{{ device.serial || "No Serial Assigned" }}</td>
        <td>{{ device.org?.name || 'No Org Assigned' }}</td>
      </tr>
    </ng-template>
  </p-table>

  <p-message
    *ngFor="let warning of orgWarnings"
    severity="warn"
    [text]="warning"
    styleClass="warning-message">
  </p-message>

  <div *ngIf="sameOrgSelected && selectedOrgName" class="p-mt-3">
    <strong>Organization:</strong> {{ selectedOrgName }}
  </div>

  <div class="p-fluid p-mt-3">
    <div class="p-field">
      <label>Device Profile to assign devices to:</label>
      <p-dropdown
        [options]="deviceConfigs"
        [(ngModel)]="deviceConfigSelected"
        placeholder="Select a Device Profile"
        optionLabel="name"
        [showClear]="true"
        appendTo="body"
        [filter]="true"
        filterBy="name"
        filterPlaceholder="Search profiles"
        [resetFilterOnHide]="true"
        [disabled]="!sameOrgSelected || isLoading">
      </p-dropdown>
    </div>
  </div>

  <div class="p-fluid p-mt-3">
    <div class="p-field">
      <label>Voice Profile to assign devices to:</label>
      <p-dropdown
        [options]="voiceConfigs"
        [(ngModel)]="voiceConfigSelected"
        placeholder="Select a Voice Profile"
        optionLabel="name"
        [showClear]="true"
        appendTo="body"
        [filter]="true"
        filterBy="name"
        filterPlaceholder="Search voice profiles"
        [resetFilterOnHide]="true"
        [disabled]="!sameOrgSelected || isLoading">
      </p-dropdown>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      icon="pi pi-check"
      (onClick)="assign()"
      [disabled]="!sameOrgSelected || (!deviceConfigSelected && !voiceConfigSelected)"
      label="Apply"
      styleClass="p-button-warning">
    </p-button>
  </ng-template>
</p-dialog>